define('views/blocks/checkout/ConfirmationCodePromptDialogView',['underscore', 'jquery', 'views/blocks/checkout/CheckoutDialogView', 'app',
        'template!blocks/checkout/dialog-confirmation-code-prompt'
    ],
    function (_,$,CheckoutDialogView, app, template){
        var view, code_size;
        return CheckoutDialogView.extend({
            name:'confirmation-code-prompt',
            events:{
                'click .btn-close':'close',
                'focus #confirmation_code':'onFocus',
                'paste #confirmation_code':'onPaste',
                'input #confirmation_code':'onInput',
                'click #request_new_code':'requestNewCode',
            },
            initialize:function(options){
                view = this;
                code_size = parseInt(options.code_size || 5);
                var new_code_cta = app.t('demander un nouveau code','Checkout')
                var new_code_btn = "<button id='request_new_code' type='button'>"+new_code_cta+"</button>"
                var new_code_mention = app.t('Vous n’avez pas reçu votre code ? Vous pouvez %s.','Checkout',new_code_btn)
                view.options = _.defaults({
                    new_code_mention: new_code_mention,
                    code_size:code_size,
                },options);
                CheckoutDialogView.prototype.initialize.apply(view, arguments);
                view.fillPlaceholder('');
            },
            fillPlaceholder:function(code){
                var codePadded = code.padEnd(code_size,'•'),
                    placeholders = view.$('.confirmation-code-prompt__placeholder');
                placeholders.each(function(i,el){
                    $(el).attr('data-char',codePadded[i]);
                });
            },
            afterIntro:function(){
                view.$('#confirmation_code').focus();
            },
            getInner:function(){
                return template(view.options);
            },
            onFocus:function(e){
                var input = e.currentTarget;
                input.select();
            },
            onPaste:function(e){
                var input = e.currentTarget,
                    text = e.originalEvent.clipboardData.getData('Text') || '';
                text = text.replace(/ /g,'')
                if(!!text){
                    input.value = text;
                    view.fillPlaceholder(text);
                    e.preventDefault();
                }
                input.select();
            },
            onInput:function(e){
                var input = e.currentTarget;
                view.fillPlaceholder(input.value);
            },
            requestNewCode:function(e){
                view.trigger('close',view,false,true);
                return false;
            },
            submit:function(e){
                var confirmation_code_input = view.$('#confirmation_code'),
                    confirmation_code = confirmation_code_input.val()
                if(!confirmation_code){
                    confirmation_code_input.addClass('alert-required',true);
                    confirmation_code_input.focus()
                }else{
                    view.trigger('close',view,confirmation_code);
                }
                return false;
            },
            close:function(){
                view.trigger('close',view);
            },
        });
    });


